"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EolStyle = void 0;
/**
 * Specifies what sort of line endings to use.
 */
var EolStyle;
(function (EolStyle) {
    /**
     * Carriage Return, followed by a line feed.  Windows-style.
     */
    EolStyle[EolStyle["Crlf"] = 0] = "Crlf";
    /**
     * Just a line feed.  Unix-style (including Mac).
     */
    EolStyle[EolStyle["Lf"] = 1] = "Lf";
})(EolStyle = exports.EolStyle || (exports.EolStyle = {}));
